import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statuto',
  templateUrl: './statuto.component.html',
  styleUrls: ['./statuto.component.css']
})
export class StatutoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
